/*
  CUSTOM CHANGE — neue Datei (komplett custom)
  Youmee.market — Seite „Hilfe & Kontakt“: Live-Suche und „Weitere Themen“
  Datei: assets/ym-support.js   Erstellt: 2026-10-19 · 2026-10-20 (v2): Themengruppen
  - „Weitere Themen“: baut unter jeder Themengruppe (Section ym-support-fragen) automatisch
    Kacheln zu allen anderen Themengruppen der Seite (Icon + Titel + Sprungmarke).
  - Suche (Section ym-support-kopf): filtert beim Tippen alle Fragen der Seite, klappt Treffer auf,
    markiert das Suchwort, blendet Gruppen ohne Treffer, die Themen-Kacheln und „Weitere Themen“ aus,
    zeigt die Trefferzahl und ohne Treffer den Hinweis mit Kontakt.
  Ohne JavaScript bleibt die Seite normal nutzbar (alle Fragen sichtbar, nur ohne „Weitere Themen“).
*/
(() => {
  if (window.ymSupportLoaded) return;
  window.ymSupportLoaded = true;

  const norm = (t) => String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim();
  const esc = (t) => t.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- Weitere Themen ---------- */
  function buildOthers() {
    const topics = Array.from(document.querySelectorAll('[data-ym-topic]'));
    topics.forEach((topic) => {
      const box = topic.querySelector('[data-ym-topic-others]');
      if (!box) return;
      const others = topics.filter((t) => t !== topic && t.id);
      box.innerHTML = '';
      if (!others.length) { box.hidden = true; return; }
      const label = document.createElement('span');
      label.className = 'ym-sp__others-label';
      label.textContent = box.dataset.label || 'Weitere Themen';
      box.appendChild(label);
      others.forEach((t) => {
        const a = document.createElement('a');
        a.className = 'ym-sp__chip';
        a.href = `#${t.id}`;
        const ico = t.querySelector('[data-ym-topic-ico] svg');
        if (ico) { const c = ico.cloneNode(true); c.setAttribute('aria-hidden', 'true'); a.appendChild(c); }
        const s = document.createElement('span');
        s.textContent = t.dataset.title || '';
        a.appendChild(s);
        box.appendChild(a);
      });
      box.hidden = false;
    });
  }

  /* ---------- Suche ---------- */
  function highlight(el, query) {
    const text = el.dataset.ymOrig || el.textContent;
    el.dataset.ymOrig = text;
    if (!query) { el.textContent = text; return; }
    const i = norm(text).indexOf(query);
    if (i < 0) { el.textContent = text; return; }
    el.innerHTML = `${esc(text.slice(0, i))}<mark>${esc(text.slice(i, i + query.length))}</mark>${esc(text.slice(i + query.length))}`;
  }

  function run(input) {
    const q = norm(input.value);
    const words = q.split(' ').filter(Boolean);
    let hits = 0;
    document.querySelectorAll('[data-ym-topic-section]').forEach((section) => {
      const topic = norm(section.dataset.title);
      let sectionHits = 0;
      section.querySelectorAll('[data-ym-faq-item]').forEach((item) => {
        const hay = `${norm(item.textContent)} ${topic}`;
        const match = !q || hay.includes(q) || words.every((w) => hay.includes(w));
        item.hidden = !match;
        if (match) sectionHits += 1;
        if (q) item.open = match; else item.open = item.dataset.ymWasOpen === 'true';
        const qEl = item.querySelector('[data-ym-faq-q]');
        if (qEl) highlight(qEl, q);
      });
      section.hidden = Boolean(q) && sectionHits === 0;
      hits += sectionHits;
    });
    document.body.classList.toggle('ym-sp-searching', Boolean(q));
    document.querySelectorAll('[data-ym-faq-empty]').forEach((el) => { el.hidden = !(q && hits === 0); });
    document.querySelectorAll('[data-ym-sp-count]').forEach((el) => {
      el.textContent = q ? (hits === 1 ? '1 passende Frage' : `${hits} passende Fragen`) : '';
    });
  }

  let timer;
  document.addEventListener('input', (e) => {
    const input = e.target.closest('[data-ym-sp-search]');
    if (!input) return;
    clearTimeout(timer);
    timer = setTimeout(() => run(input), 120);
  });
  document.addEventListener('submit', (e) => {
    if (!e.target.closest('[data-ym-sp-form]')) return;
    e.preventDefault();
    const input = e.target.querySelector('[data-ym-sp-search]');
    if (input) run(input);
  });
  document.addEventListener('toggle', (e) => {
    const item = e.target;
    if (item.matches && item.matches('[data-ym-faq-item]') && !document.body.classList.contains('ym-sp-searching')) item.dataset.ymWasOpen = item.open ? 'true' : 'false';
  }, true);

  /* Sprung auf ein Thema: Suche leeren, damit alles sichtbar ist */
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (!link || !document.body.classList.contains('ym-sp-searching')) return;
    document.querySelectorAll('[data-ym-sp-search]').forEach((i) => { i.value = ''; run(i); });
  });

  const boot = () => buildOthers();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', () => setTimeout(boot, 50));
})();
